import React, { Suspense, useContext, useState } from "react";

import LayoutDashboard from "layouts/layout-dashboard-collapse"; // Assuming this is a layout component

import FullLoader from "components/loader/full-loader";
import { Dropdown } from "react-bootstrap";
import { useDeleteData, useFetchData } from "hooks/useApiHooks";
import { AppContext } from "contexts/AppContext";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./components/create-page";
import { useDeleteHandler } from "hooks/useDeleteHandler";
import { buildQueryString } from "utils/queryHelpers";
import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import HistoryPage from "./components/history-agent";
import { usePaymentMethod } from "contexts/v1/masterData/PaymentMethodContext";
import Swal from "sweetalert2";
import { deleteRequest } from "services/api";
import { formatPrice, formatTax } from "utils/utils";

const MetodePembayaranPage = () => {
  const { paymentMethods, refetch } = usePaymentMethod();
  const [currentPage, setCurrentPage] = useState(1); // For pagination

  const { handleSuccess, handleError, showCanvasHandler, handleSuccessToast } =
    useCanvasHandler();

  const handleCreate = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create Payment Method",
      <CreatePage
        onSuccess={() => {
          handleSuccessToast(true, "Label createing");
          refetch();
        }}
        onError={handleError}
      />
    );
  };

  const handleUpdate = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Update Payment Method",
      <CreatePage
        initialData={data}
        onSuccess={() => {
          handleSuccessToast(true, "Label updateding");
          refetch();
        }}
        onError={handleError}
      />
    );
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteRequest(`/payment-method/${id}`);

        if (response.success) {
          handleSuccessToast(true, "Label deleteing");
          refetch();
        }
      }
    });
  };

  const totalPages = paymentMethods.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages,
    currentPage,
    onPageChange: setCurrentPage,
    visiblePages: 5, // Optional: number of visible pages in pagination (default is 5)
  });

  if (paymentMethods.loading) return <FullLoader />;
  if (paymentMethods.error) return <Suspense error={paymentMethods.error} />;
  return (
    <LayoutDashboard>
      <div className="container-fluid mt-5">
        <div className="table-container">
          <div className="search-container mb-3">
            <SearchInput />

            <button className="btn btn-primary" onClick={handleCreate}>
              Create
            </button>
          </div>

          <div className="table table-responsive">
            <table className="table table-hover table-vcenter">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Nama</th>
                  <th>Tax</th>
                  <th className="text-end">Show in POS</th>
                  <th className="text-end">Show in Reservation</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>
              {paymentMethods.data.length > 0 && (
                <tbody>
                  {paymentMethods.data.map((data, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{data.name}</td>
                        <td>{formatTax(data.tax)} %</td>
                        <td className="text-end">
                          {data.show_pos ? "Yes" : "No"}
                        </td>
                        <td className="text-end">{data.show_reservation ? "Yes" : "No"}</td>

                        <td className="text-end">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="default"
                              id="dropdownMenuButton1"
                            >
                              Actions
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => handleUpdate(e, data)}
                              >
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDelete(data.id);
                                }}
                              >
                                Remove
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              )}
            </table>
          </div>

          <div className="mt-4">{Pagination}</div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default MetodePembayaranPage;

// Search Input Component
const SearchInput = () => {
  const { handleSearch, filterOptions } = usePaymentMethod();
  const [search, setSearch] = useState(filterOptions.search || "");

  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
      />
      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};
